import componentSchema from "./component.js";

const Schemas =
{
    component : componentSchema
};

export default Schemas;
